const currentQuiz = state => state.currentQuiz
const previousAttempt = state => state.previousAttempts.results[0]
const previousAttemptCount = state => state.previousAttempts.count || 0
const currentAttempt = state => state.currentAttempt
const finishedAttempt = state => state.finishedAttempt

export default {
  currentQuiz,
  previousAttempt,
  currentAttempt,
  finishedAttempt,
  previousAttemptCount,
}
